import React from 'react';
import NewsIconWrapper from './NewsIconWrapper';

export default function NewOffers(props) {
  return (
    <NewsIconWrapper {...props}>
      <circle cx="16" cy="16" r="16" fill="#6FCF97" fillOpacity="0.4"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M11.25 16.5L8.75 13H7.5V19H8.75V15.5L11.3 19H12.5V13H11.25V16.5ZM13.5 19H17.5V17.75H15V16.64H17.5V15.38H15V14.26H17.5V13H13.5V19ZM23.25 17.5V13H24.5V18C24.5 18.55 24.05 19 23.5 19H19.5C18.95 19 18.5 18.55 18.5 18V13H19.75V17.51H20.88V13.99H22.13V17.5H23.25Z" fill="black" fillOpacity="0.54"/>
    </NewsIconWrapper>
  );
}
